import styles from "./Advisors.module.scss";
import Image from "next/image";
import { useTranslation } from "next-i18next";
import { FC } from "react";
import DavidAddisonImage from "@cs/public/img/about/DavidAddison.jpeg";
import SophieGalloisImage from "@cs/public/img/about/SophieGallois.jpeg";
import MarianaCastanoCanoImage from "@cs/public/img/about/MarianaCastanoCano.jpeg";
import MirikImage from "@cs/public/img/people/mirik.jpg";

export const Advisors = () => {
  const { t } = useTranslation("about");

  return (
    <section className={styles.advisors}>
      <h3 className={styles.title}>{t("advisors.title")}</h3>
      <div className={styles.advisorsSection}>
        {
          ADVISORS.map((advisor, index) => (
            <Advisor key={index} {...advisor} />
          ))
        }
      </div>
    </section>
  );
};

const ADVISORS: AdvisorsProps[] = [
  {
    code:"sophie-gallois",
    image:SophieGalloisImage
  },
  {
    code:"mariana-castaño-cano",
    image:MarianaCastanoCanoImage
  },
  {
    code:"mirik-gogri",
    image:MirikImage
  },
  {
    code: "david-addison",
    image: DavidAddisonImage
  }
];


interface AdvisorsProps {
  image: StaticImageData
  code: string
}

const Advisor: FC<AdvisorsProps> = ({ image, code }) => {
  const {t} = useTranslation("about")
  const transSnippet = (value:string) => `advisors.people.${code}.${value}` 
 
  return (
    <div className={styles.advisor}>
      <div className={styles.image}>
        <figure className={styles.figure}>
          <Image
            src={image}
            alt={`Profile pic of ${t(transSnippet('name'))}`}
            layout="responsive"
          />
        </figure>
        <p className={styles.description}>
          {t(transSnippet('description'))}
        </p>
      </div>
      <h4 className={styles.name}>
        {t(transSnippet('name'))}
      </h4>
      <h5 className={styles.role}>
        {t(transSnippet('role'))}
      </h5>
    </div>
  );
}